const dataSetAction = {
    NEW_DATA_SET : 'new data set',

    EXPORT : 'export',

    BACKUP : 'backup',

    SAVE : 'save',

    DISCARD_CHANGES : 'discard changes',

    DATA_SET_SETTINGS : 'data set settings',

    VIEW_REFERENCES : 'view references',

    DELETE : 'delete'

};

angular.module('gw-um-j2js')
    .constant('dataSetAction', dataSetAction);